import { Box, Checkbox, FormControlLabel, Grid, Typography } from "@mui/material";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import MuiDialogActions from '@mui/material/DialogActions';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import { makeStyles, withStyles } from '@mui/styles';
import CloseIcon from '@mui/icons-material/Close';
import React, { useState } from 'react';

const useStyles = makeStyles(theme => ({
    root: {
        minWidth: '400px'
    },
    notesHeader: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(1.5),
    },
    dialogWidth: {
        overflow: 'hidden',
        minWidth: '400px',
    },
    ErrorName: {
        color: 'red',
    },
    nameContainer: {
        margin: 15,
        display: 'flex',
        flexGrow: '1',
        flexDirection: 'column'
    },
    formLabel: {
        color: theme.palette.primary.main,
        fontWeight: 500,
    },
    userLabel: {
        paddingLeft: '10px',
    },
    addButton: {
        position: 'relative',
        top: theme.spacing(-4),
        paddingRight: theme.spacing(1)
    },
    progress: {
        marginLeft: '50%',

    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
}));

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
        backgroundColor: `${theme.palette.mode === 'dark' ? '#16191c' : theme.palette.primary.main} !important`,
        color: `${theme.palette.mode === 'dark' ? theme.palette.text.primary : '#fff'} !important`
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: `${theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.grey[500]} !important`,
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography className="font500" variant="subtitle1" noWrap>{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: '0px 0px',
        [theme.breakpoints.down(281)]: {
            width: '218px',
        },
        [theme.breakpoints.between(281, 322)]: {
            width: '258px',
        },
        [theme.breakpoints.between(321, 556)]: {
            width: '275px'
        },
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

const SkillDataDialogue = (props) => {
    const classes = useStyles();
    const [updatedName, setUpdateName] = useState(props.Name);
    const [includeFilter, setIncludeFilter] = useState(props.includeUnderSearchFilter);
    const [errorText, setErrorText] = useState("");

    const handleClose = () => {
        props.handleCloseClick();
    };

    const errorCheck = (value) => {

        const charactersExp = new RegExp("[^a-zA-Z0-9_@&.,')( ]");
        setUpdateName(value);
        if (!value)
            setErrorText("Name is required.");
        else if (value.match(charactersExp) || value.trim() == '') {
            setErrorText("Please enter valid name.");
        } else {
            setErrorText(null);
        }
    }

    const handleChange = (event) => {
        errorCheck(event.target.value);
    };

    const handleSubmit = () => {

        errorCheck(updatedName);
        if (updatedName && !errorText) {
            props.onSubmitClick(updatedName.trim(), null, includeFilter);
        }
    };

    const handleUpdateManaged = (e) => {
        setIncludeFilter(e.target.checked)
    };

    return (
        <div>
            <Dialog maxWidth="sm" onClose={handleClose} aria-labelledby="customized-dialog-title" open={props.open}
                PaperProps={{ sx: { backgroundColor: (t) => t.palette.mode === 'dark' ? '#000' : undefined, backgroundImage: 'none' } }}>
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    {props.action}
                </DialogTitle>
                <DialogContent dividers className={classes.dialogWidth}>
                    <Grid container alignItems='center'>
                        <Box sx={{display: 'flex', flexDirection: 'column'}}>
                            <Grid>
                                <div className={classes.nameContainer}>
                                    <TextField id="DataField" variant="outlined" fullWidth={true}
                                        label={<Typography variant="body2">Name</Typography>}
                                        size="small"
                                        value={updatedName}
                                        name="Name"
                                        onChange={handleChange}
                                        error={errorText}
                                        inputProps={{ maxLength: 150 }}
                                    />
                                    {errorText && <Typography className={classes.ErrorName} variant="body2">{errorText}</Typography>}
                                </div>
                            </Grid>
                            <Grid>
                                <div className={classes.nameContainer}>
                                    <FormControlLabel
                                        className={classes.invite}
                                        label="Include this skill under filter options"
                                        labelPlacement='end'
                                        control={
                                            <Checkbox
                                                checked={includeFilter}
                                                onChange={handleUpdateManaged}
                                                name="includeFilter"
                                                color="primary"
                                            />
                                        }

                                    />
                                </div>
                            </Grid>
                        </Box>
                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleSubmit} color="primary">
                        Save</Button>
                    <Button
                        onClick={props.onCancelClick}
                        color="primary"
                        autoFocus>Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </div >
    );
}

export default SkillDataDialogue;